import styled from 'styled-components';

const SearchHeaderContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
`;

export default SearchHeaderContainer;
